
export default {
  name: 'Diversity',
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
}
